import {
  CcfBox,
  CcfIlluminateStarIcon,
  CcfPlusFolderIcon,
  CcfSendIcon,
  CcfSparklesIcon,
  CcfTextField,
  CcfTickIcon,
  CcfTypography,
  CcfUpArrowIcon,
  useTranslator,
} from '@nice-ccf/ui-controls';
import styles from './ccf-copilot-nbr.module.scss';
import { Button, IconButton, Paper, useTheme } from '@mui/material';
import React, { useEffect, useRef, useState } from 'react';
import Carousel from 'react-material-ui-carousel';
import {
  ArrowBackIosOutlined,
  ArrowForwardIosOutlined,
} from '@mui/icons-material';
import makeStyles from '@mui/styles/makeStyles';
import { useDispatch, useSelector } from 'react-redux';
import {
  activeContactSelector,
  getActiveInteractionID,
  updateTwitterAgentReply,
} from '../../../../ccf-inbox/ccf-inbox.slice';
import {
  getCopilotAppSpaceArticle,
  getCopilotSuggestionToReplyBoxState,
  getIsAssetsAddedToCopilotSuggestionState,
  getSelectedCopilotAssets,
  getcopilotFlowMsgIndex,
  setIsAssetsAddedToCopilotSuggestion,
  setSelectedCopilotAssets,
  updateFlowMsgIndex,
} from '../+state/ccf-copilot.slice';
import { useMsal } from '@azure/msal-react';
import {
  getIsResponseInserted,
  getIsResponseSent,
  getSentBestResponse,
} from '../+state/ccf-live-copilot.slice';

/* eslint-disable-next-line */
export interface CcfCopilotNBRProps {
  sliderItemsArr: any;
}

const useStyles = makeStyles({
  suggestionField: {
    display: 'flex',
    justifyContent: 'center',
    minHeight: '48px',
    background: '#F7F7F7',
    whiteSpace: 'normal',
  },
  suggestionInputPropsStyle: {
    '&.MuiInputBase-root': {
      color: '#3F5C69',
      fontFamily: 'Open Sans',
      fontSize: '12px',
      fontStyle: 'normal',
      fontWeight: '400',
      lineHeight: '125%',
      paddingLeft: '10px',
    },
  },
});
/**
 * Function to set current value of edited suggestion
 * @param event -any
 * @example updateCurrentValue
 */
export function CcfCopilotNBR(props: CcfCopilotNBRProps) {
  const { sliderItemsArr } = props;
  const [currentVal, setCurrentVal] = useState('');
  const [showTick, setShowTick] = useState(null);
  const { accounts } = useMsal();
  const loginCredentialsFromSSO = accounts[0]?.name || ' ';
  const loginCredentialsArray = loginCredentialsFromSSO?.split(' ');
  const theme = useTheme();
  const [translate] = useTranslator();
  //const initials = loginCredentialsArray[0].charAt(0).toUpperCase() + loginCredentialsArray[1].charAt(0).toUpperCase()
  const inititateCopilotSuggestionToReplyBox = useSelector(
    getCopilotSuggestionToReplyBoxState
  );
  const copilotSuggestions = useSelector(getCopilotAppSpaceArticle);
  const flowMsgIndex = useSelector(getcopilotFlowMsgIndex);
  const activeInteractionID: string = useSelector(getActiveInteractionID) || '';
  const activecontact = useSelector(activeContactSelector);
  const activecontactId = activecontact?.id || '';
  const sentNextBestResponse = useSelector(
    getSentBestResponse(activecontactId)
  );
  const isNextBestResponseInserted: boolean | undefined = useSelector(
    getIsResponseInserted(activecontactId)
  );
  const isNextBestResponseSent: boolean | undefined = useSelector(
    getIsResponseSent(activecontactId)
  );
  const classes = useStyles();
  const dispatch = useDispatch();
  const isAssetsAddedToCopilotSuggestion = useSelector(
    getIsAssetsAddedToCopilotSuggestionState
  );
  const selectedCopilotAssets = useSelector(getSelectedCopilotAssets);
  const [stopFlowJourneyFlag, setStopFlowJourneyFlag] = useState(false);
  useEffect(() => {
    if (isNextBestResponseSent) {
      if (sentNextBestResponse.startsWith('Link')) {
        const linkContent = sentNextBestResponse.slice(6);
        sendBtnHandler(
          {
            text: '',
            linkContent: [linkContent],
            imageContent: [],
            processContent: [],
          },
          false
        );
      } else if (sentNextBestResponse.startsWith('IMAGE')) {
        const imgContent = sentNextBestResponse.split(':');
        sendBtnHandler(
          {
            text: '',
            linkContent: [],
            imageContent: [imgContent[1]],
            processContent: [],
          },
          false
        );
      } else {
        sendBtnHandler(
          {
            text: sentNextBestResponse,
            linkContent: [],
            imageContent: [],
            processContent: [],
          },
          false
        );
      }
    }
  }, [isNextBestResponseSent]);

  useEffect(() => {
    if (isNextBestResponseInserted) {
      dispatch(setIsAssetsAddedToCopilotSuggestion(true));
      setStopFlowJourneyFlag(true);
      if (sentNextBestResponse.startsWith('Link')) {
        const linkContent = sentNextBestResponse.slice(6);
        dispatch(
          setSelectedCopilotAssets({
            ...selectedCopilotAssets,
            webLinks: [...selectedCopilotAssets.webLinks, linkContent],
          })
        );
      } else if (sentNextBestResponse.startsWith('IMAGE')) {
        const imgContent = sentNextBestResponse.split(':');
        dispatch(
          setSelectedCopilotAssets({
            ...selectedCopilotAssets,
            images: [...selectedCopilotAssets.images, imgContent[1]],
          })
        );
      } else {
        setCurrentVal(sentNextBestResponse);
      }
    }
  }, [isNextBestResponseInserted]);

  /**
   * Function to set height of interaction post
   * @param event -any
   * @example isEmail
   */
  const formatMsgTime = () => {
    const date = new Date();
    const result = date.toUTCString();
    return result;
  };

  /**
   * Function to set current value of edited suggestion
   * @param event -any
   * @example updateCurrentValue
   */
  const updateCurrentValue = (e: any) => {
    setCurrentVal(e.currentTarget.value);
  };

  /**
   * processSuggestion - process suggestion in chat text editor to next state
   * @param props -?-suggestion
   * @example processSuggestion()
   */
  const processSuggestion = (iconID: number, suggestion: any, i: any) => {
    if (iconID === 1) {
      setCurrentVal(suggestion);
      setShowTick(i);
    } else {
      sendBtnHandler(
        {
          text: suggestion,
          linkContent: [],
          imageContent: [],
          processContent: [],
        },
        true
      );
    }
    dispatch(setIsAssetsAddedToCopilotSuggestion(true));
  };

  /**
   * processSuggestion - process suggestion in chat text editor to next state
   * @param props -?-suggestion
   * @example processSuggestion()
   */
  const sendBtnHandler = (payload: any, updateFlowJourney?: boolean) => {
    console.log('send');
    if (updateFlowJourney) {
     
        dispatch(updateFlowMsgIndex(flowMsgIndex + 1));
      
    }
    const replyMessage = {
      messageId: new Date().toString(),
      postId: 'chat_b8f6e4f2_a8af_4607_b7e8_e3b5d748b09d',
      isOwn: true,
      createdAt: formatMsgTime(),
      messageContent: {
        payload: payload,
      },
      reactionStatistics: {
        likes: 0,
      },
      authorUser: {
        firstName:
          loginCredentialsArray[0].charAt(0).toUpperCase() +
          loginCredentialsArray[0].slice(1).toLowerCase(),
        surname:
          loginCredentialsArray[1].charAt(0).toUpperCase() +
          loginCredentialsArray[1].slice(1).toLowerCase(),
        emailAddress: 'customer.service@delta.com',
        loginUsername: '',
      },
      attachments: [],
      conferenceMsg: false,
    };
    setStopFlowJourneyFlag(false);
    dispatch(
      updateTwitterAgentReply({
        interactionId: activeInteractionID,
        replyMessage,
      })
    );
    setShowTick(null);
    setCurrentVal('');
    dispatch(setIsAssetsAddedToCopilotSuggestion(false));
    if (
      selectedCopilotAssets.images.length > 0 ||
      selectedCopilotAssets.webLinks.length > 0 ||
      selectedCopilotAssets.processes.length > 0
    ) {
      dispatch(
        setSelectedCopilotAssets({
          webLinks: [],
          images: [],
          processes: [],
        })
      );
    }
    setTimeout(() => {
      document.getElementById('bodyContainer')?.scroll({
        top: document.getElementById('bodyContainer')?.scrollHeight, //scroll to the bottom of the element
        behavior: 'smooth', //auto, smooth, initial, inherit
      });
    }, 1000);
  };

  /**
   * processSuggestion - process suggestion in chat text editor to next state
   * @param props -?-suggestion
   * @example processSuggestion()
   */
  const renderSlider = () => (
    <Carousel
      autoPlay={false}
      animation="slide"
      navButtonsAlwaysVisible={true}
      className={styles.carousel}
      fullHeightHover={false}
      NextIcon={<ArrowForwardIosOutlined style={{ marginRight: '-15px' }} />}
      PrevIcon={<ArrowBackIosOutlined style={{ marginLeft: '-15px' }} />}
      navButtonsProps={{
        style: {
          backgroundColor: '#fff',
          borderRadius: 0,
          color: 'rgba(0, 0, 0, 0.54)',
        },
      }}
      navButtonsWrapperProps={{
        style: {
          bottom: '0',
          top: 'unset',
        },
      }}
    >
      {sliderItemsArr.map((sliderItem: any, i: any) => (
        <CcfBox className={styles.suggestionCard} key={i}>
          <CcfSparklesIcon
            htmlColor={theme?.palette?.primary?.main}
            viewBox="0 0 20 23"
          />
          <CcfTypography className={styles.suggestionTxt}>
            {sliderItem}
          </CcfTypography>
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-between',
            }}
          >
            <IconButton
              id="nbrSendToReplyBoxBtn"
              style={{ opacity: 1, width: '30px' }}
              onClick={() => processSuggestion(1, sliderItem, i)}
            >
              {showTick === i ? (
                <CcfTickIcon fillColor={'#278A35'} />
              ) : (
                <CcfPlusFolderIcon fillColor={'#526B7A'} />
              )}
            </IconButton>
            <IconButton
              id="nbrSendToChatBtn"
              style={{ opacity: 1, width: '30px' }}
              onClick={() => processSuggestion(2, sliderItem, i)}
            >
              <CcfSendIcon className={styles.sendIcon} fillColor={'#526B7A'} />
            </IconButton>
          </div>
        </CcfBox>
      ))}
    </Carousel>
  );

  /**
   * renderTextField - to render text field in chat text editor
   * @param props -?-
   * @example renderTextField()
   */
  const renderTextField = () => (
    <CcfTextField
      fullWidth
      multiline={true}
      autoFocus
      id="suggestion"
      variant="standard"
      size="medium"
      value={currentVal}
      style={{ whiteSpace: 'pre-wrap' }}
      className={classes.suggestionField}
      InputProps={{
        className: classes.suggestionInputPropsStyle,
        disableUnderline: true,
        placeholder: translate('Typeareplyhere'),
      }}
      onChange={(e) => updateCurrentValue(e)}
    />
  );

  /**
   * processSuggestion - process suggestion in chat text editor to next state
   * @param props -?-suggestion
   * @example processSuggestion()
   */
  const renderSendButton = () => (
    <Button
      id="chatSendBtn"
      size="medium"
      variant="contained"
      onClick={() =>
        sendBtnHandler(
          {
            text: currentVal,
            linkContent: selectedCopilotAssets.webLinks,
            imageContent: selectedCopilotAssets.images,
            processContent: selectedCopilotAssets.processes,
          },
          stopFlowJourneyFlag ? false : true
        )
      }
      color="primary"
      disabled={
        isAssetsAddedToCopilotSuggestion
          ? currentVal.length === 0
            ? true
            : false
          : true
      }
    >
      {translate('send')}
    </Button>
  );

  return !isAssetsAddedToCopilotSuggestion ? (
    <>
      {sliderItemsArr.length > 0 && renderSlider()}
      <CcfBox display={'flex'} flexDirection={'column'} gap={1}>
        {renderTextField()}
        <CcfBox
          display={'flex'}
          flexDirection={'row'}
          justifyContent={'flex-end'}
          style={{ paddingTop: '5px' }}
        >
          {renderSendButton()}
        </CcfBox>
      </CcfBox>
    </>
  ) : (
    <CcfBox display={'flex'} flexDirection={'column'}>
      <CcfBox
        style={{
          border: !isAssetsAddedToCopilotSuggestion
            ? '1px solid black'
            : 'none',
        }}
      >
        {renderTextField()}
        <CcfBox className={styles.assetsFieldBox} contentEditable>
          <CcfBox
            style={{
              display:
                selectedCopilotAssets.webLinks.length > 0 ? 'block' : 'none',
            }}
          >
            {selectedCopilotAssets.webLinks.length > 0 &&
              selectedCopilotAssets.webLinks.map((link: any, index: number) => {
                return (
                  <CcfTypography className={styles.txt} key={index}>
                    Link: <span className={styles.link}>{link}</span>
                  </CcfTypography>
                );
              })}
          </CcfBox>
          <CcfBox
            className={styles.imageBlock}
            style={{
              display:
                selectedCopilotAssets.images.length > 0 ? 'block' : 'none',
            }}
          >
            {selectedCopilotAssets.images.length > 0 &&
              selectedCopilotAssets.images.map((image: any, index: number) => {
                return (
                  <img
                    key={index}
                    className={styles.imageBox}
                    alt={index.toString()}
                    src={image}
                  />
                );
              })}
          </CcfBox>
          <CcfBox
            style={{
              display:
                selectedCopilotAssets.processes.length > 0 ? 'block' : 'none',
            }}
          >
            {selectedCopilotAssets.processes.length > 0 &&
              selectedCopilotAssets.processes.map(
                (process: any, index: number) => {
                  return (
                    <CcfTypography className={styles.txt} key={index}>
                      <span className={styles.link}>{`${index + 1}.  ${
                        process.description
                      }`}</span>
                    </CcfTypography>
                  );
                }
              )}
          </CcfBox>
        </CcfBox>
      </CcfBox>
      <CcfBox
        display={'flex'}
        flexDirection={'row'}
        justifyContent={'flex-end'}
        style={{ paddingTop: '5px' }}
      >
        {renderSendButton()}
      </CcfBox>
    </CcfBox>
  );
}

export default CcfCopilotNBR;
